<section id="ability-section" class="bg-white py-36 px-4">
  <div class="container relative text-gray-800">
    <h2 class="text-3xl font-extrabold mb-20 text-center capitalize">
      Mes <span class="text-blue-800"> compétences</span>
    </h2>
    <div
      class="grid lg:grid-cols-2 md:grid-cols-1 gap-1 justify-items-stretch lg:px-20 px-0"
    >
      <div class="px-8 mb-10">
        <h3 class="text-center text-2xl mb-2">Langages</h3>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200"
              >
                PHP
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-blue-600"
                >A 100%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200"
          >
            <div
              style="width:100%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200"
              >
                SQL
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-blue-600">
                90%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200"
          >
            <div
              style="width:90%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200"
              >
                HTML
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-blue-600">
                100%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200"
          >
            <div
              style="width:100%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200"
              >
                CSS
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-blue-600">
                100%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200"
          >
            <div
              style="width:100%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200"
              >
                Javascript
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-blue-600">
                100%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200"
          >
            <div
              style="width:100%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200"
              >
                SASS
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-blue-600">
                70%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200"
          >
            <div
              style="width:70%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
            />
          </div>
        </div>
      </div>
      <div class="px-8 mb-10">
        <h3 class="text-center text-2xl mb-2">Librairies / Framework</h3>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-green-600 bg-green-200"
              >
                Symfony
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-green-600">
                95%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-green-200"
          >
            <div
              style="width:95%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-green-600 bg-green-200"
              >
                jQuery
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-green-600">
                95%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-green-200"
          >
            <div
              style="width:95%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-green-600 bg-green-200"
              >
                ReactJS
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-green-600">
                50%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-green-200"
          >
            <div
              style="width:50%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-green-600 bg-green-200"
              >
                NextJS
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-green-600">
                50%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-green-200"
          >
            <div
              style="width:50%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-green-600 bg-green-200"
              >
                SvelteJS
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-green-600">
                60%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-green-200"
          >
            <div
              style="width:60%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-green-600 bg-green-200"
              >
                Strapi
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-green-600">
                75%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-green-200"
          >
            <div
              style="width:75%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
            />
          </div>
        </div>
      </div>
      <div class="px-8 col-span-1 w-full lg:col-span-2 lg:w-1/2 mx-auto">
        <h3 class="text-center text-2xl mb-2">Outils / Autres</h3>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-gray-900 bg-gray-200"
              >
                Visual studio code
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-gray-900">
                90%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-gray-200"
          >
            <div
              style="width:90%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-gray-900"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-gray-900 bg-gray-200"
              >
                PHPStorm
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-gray-900">
                90%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-gray-200"
          >
            <div
              style="width:90%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-gray-900"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-gray-900 bg-gray-200"
              >
                Git
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-gray-900">
                80%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-gray-200"
          >
            <div
              style="width:80%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-gray-900"
            />
          </div>
        </div>
        <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between">
            <div>
              <span
                class="text-xs font-semibold inline-block py-1 px-2 rounded-full text-gray-900 bg-gray-200"
              >
                GitHub
              </span>
            </div>
            <div class="text-right">
              <span class="text-xs font-semibold inline-block text-gray-900">
                90%
              </span>
            </div>
          </div>
          <div
            class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-gray-200"
          >
            <div
              style="width:90%"
              class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-gray-900"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
